<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_1207_12818)">
    <path d="M8.0013 0.666016C3.93464 0.666016 0.667969 3.93268 0.667969 7.99935C0.667969 12.066 3.93464 15.3327 8.0013 15.3327C12.068 15.3327 15.3346 12.066 15.3346 7.99935C15.3346 3.93268 12.068 0.666016 8.0013 0.666016ZM7.0013 11.3994L3.26798 7.66602L4.66797 6.26601L6.93465 8.53267L11.2013 4.26601L12.6013 5.66602L7.0013 11.3994Z" fill="#0E8345"/>
  </g>
  <defs>
  <clipPath id="clip0_1207_12818">
    <rect width="16" height="16" fill="white"/>
  </clipPath>
  </defs>
</svg>
  